import loadable from '@loadable/component';

export const OrgDashboardRepostJobPageContainerLoadable = loadable(
  () => import('./OrgDashboardRepostJobPageContainer'),
  { resolveComponent: (module) => module.OrgDashboardRepostJobPageContainer },
);
